<header class="app-header risk-header">
  <nav class="navbar navbar-dark navbar-expand-lg">
    <!--<a class="navbar-brand" routerLink="/"></a>-->
    <a [queryParams]="{ rbc: true }" [routerLink]="'/'"
      ><img alt="Enin logo" class="nav-brand-image" height="25" src="app/assets/img/logo_white_symbol.svg"
    /></a>
    <button
      (click)="toggleCollapse()"
      aria-expanded="false"
      class="order-2 order-lg-3 navbar-toggler"
      navbar-toggler
      style="padding: 6px 6px; margin: 0 6px; border: none; color: white"
      type="button">
      <i class="fa fa-bars fa-lg"></i>
      <!--<span class="navbar-toggler-icon"></span>-->
    </button>

    <!---
    Helpful Bootstrap NOTES
    order-1, order-2... is the order from left to right they will appear when screen is not LG.
    order-lg is the order for large screen
    Order is important so items are not included in the collapse-dropdown.
    Whatever is in the collapse-dropdown need to have the highest order.

    ms-auto is margin left auto, meaning it will float towards right

    use d-flex and flex row to get proper flexing for nav items that are not inside navbar-collapse.
    everything in navbar collapse will be collapsed except when we are on large screen -> "navbar-expand-lg"  --->

    <!--&lt;!&ndash;User/customer navigation&ndash;&gt;-->
    <!--<ul class="nav navbar-nav navbar-right order-2-on-smaller order-3" *ngIf="appIdentity">-->
    <!--</ul>-->

    <!--Collapsed content-->
    <div
      class="order-3 order-lg-1 navbar-collapse {{ collapsedNav ? 'collapse' : 'collapse show' }}"
      id="navbarSupportedContent">
      <nk-header-nav></nk-header-nav>
      <!--Only visible in mobile screens-->
      <div
        *ngIf="appIdentity?.app_customer"
        class="d-md-none d-md-none d-lg-none d-xl-none mt-2 pt-2"
        style="border-top: solid 1px white">
        <ul class="navbar-nav me-auto header-navbar">
          <li class="nav-item">
            <a [routerLink]="['/settings', 'user']" class="nav-link me-2 ms-2">
              <i class="me-1 icon-wrench"></i> {{ 'header_menu.user_settings' | translate }}
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['/settings', 'customer']" class="nav-link me-2 ms-2">
              <i class="me-1 icon-wrench"></i>
              {{ 'header_menu.customer_settings' | translate: { customerName: customerName } }}
            </a>
          </li>
          <li class="nav-item">
            <a
              *ngIf="activeFeatures && activeFeatures.flags.custom_company_report"
              [routerLink]="['/files', 'templates']"
              class="nav-link me-2 ms-2">
              <i class="me-1 icon-folder"></i> {{ 'header_menu.template_manager' | translate }}
            </a>
          </li>
          <li *ngIf="appMemberships && appMemberships.length > 1" class="nav-item">
            <button (click)="onChangeAccount()" class="nav-link me-2 ms-2">
              <i class="me-1 icon-logout"></i> {{ 'header_menu.change_user_account' | translate }}
            </button>
          </li>
          <li class="nav-item">
            <a (click)="logout()" class="nav-link me-2 ms-2" href="#">
              <i class="me-1 icon-logout"></i>
              {{
                loggedInWithIdentityProvider
                  ? ('header_menu.logout_of_enin' | translate)
                  : ('header_menu.logout' | translate)
              }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- Not collapsed -->
    <div class="d-flex flex-row order-1 order-lg-2 ms-auto">
      <ul class="navbar-nav flex-row">
        <li *ngIf="activeFeatures && activeFeatures.flags.base" class="nav-item align-self-center">
          <nk-top-search></nk-top-search>
        </li>

        <li *ngIf="!appIdentity">
          <a (click)="logout()" class="btn btn-s m btn-primary ms-2" href="#"><i class="icon-logout"></i> Logout</a>
        </li>
        <li
          *ngIf="appIdentity?.app_customer"
          class="nav-item dropdown d-none d-sm-block ms-2 me-3 align-self-center"
          dropdown
          id="nk-top-menu-user">
          <div dropdownToggle style="cursor: pointer">
            <button [attr.data-cy]="'top-menu-user-button'" class="top-menu-icon">
              <i class="fa fa-user"></i>
            </button>
          </div>

          <div *dropdownMenu class="dropdown-menu dropdown-menu-right" style="width: 230px">
            <div class="dropdown-header text-center" style="white-space: pre-wrap">
              <h5 class="mb-1">{{ appIdentity.app_user.name }}</h5>
              <h6 class="mb-0">{{ customerName }}</h6>
            </div>
            <a
              [attr.data-cy]="'top-menu-user-user-settings'"
              [routerLink]="['/settings', 'user']"
              class="dropdown-item">
              <i class="icon-wrench me-2"></i> {{ 'header_menu.user_settings' | translate }}
            </a>
            <a
              [attr.data-cy]="'top-menu-user-customer-settings'"
              [routerLink]="['/settings', 'customer']"
              class="dropdown-item">
              <i class="icon-wrench me-2"></i>
              {{ 'header_menu.customer_settings' | translate: { customerName: customerName } }}
            </a>
            <a
              *ngIf="activeFeatures.flags.custom_company_report"
              [attr.data-cy]="'top-menu-user-files-template-manager'"
              [routerLink]="['/files', 'templates']"
              class="dropdown-item">
              <i class="icon-folder me-2"></i> {{ 'header_menu.template_manager' | translate }}
            </a>
            <a
              (click)="onChangeAccount()"
              *ngIf="appMemberships && appMemberships.length > 1"
              [attr.data-cy]="'top-menu-user-change-account'"
              class="dropdown-item"
              href="javascript:void(0);">
              <i class="icon-refresh me-2"></i> {{ 'header_menu.change_user_account' | translate }}
            </a>
            <a
              (click)="logout()"
              [attr.data-cy]="'top-menu-user-logout'"
              class="dropdown-item"
              href="javascript:void(0);">
              <i class="icon-logout me-2"></i>
              {{
                loggedInWithIdentityProvider
                  ? ('header_menu.logout_of_enin' | translate)
                  : ('header_menu.logout' | translate)
              }}
            </a>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</header>
